import ControlModule from 'scripts/poppet/control-module';
import template      from 'templates/controlTechnical.jst.html';

const selectors = {
	regionContainer: '[data-region=technical-container]',
	toggleButton   : '[data-toggle=expand-spoiler]',
};

const ControlTechnicalView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : 'unit:control:technical',
	compressedNavState: 'unit:control:overview',
	
	className: function () {
		return this._getClassName( 'control-details' );
	},
	
	ui: {
		toggle: selectors.toggleButton,
	},
	
	events: {
		'click @ui.toggle': 'onClickToggle', // super
	},
	modelEvents: {
		'change': 'onModelChange',
	},
	
	onModelChange: function () {
		this.idle();
		this.render();
	},
});

export default ControlTechnicalView;